var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTrophy = function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__a",
    cx: 0.41,
    cy: 1.272,
    r: 1.728,
    gradientTransform: "matrix(.544 0 0 1 .228 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e08f48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__o",
    cx: -0.329,
    cy: 0.905,
    r: 0.884,
    gradientTransform: "matrix(3.411 0 0 1 -1.205 0)",
    xlinkHref: "#trophy_svg__a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__b",
    cx: -0.377,
    cy: 0.577,
    r: 0.6,
    gradientTransform: "matrix(2.991 0 0 1 -.996 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#faee67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#ece161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#d6cc58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b6ae4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#8e873a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#5c5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#22210e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__p",
    cx: 0.219,
    cy: 0.379,
    r: 0.745,
    gradientTransform: "matrix(.991 0 0 1 .005 0)",
    xlinkHref: "#trophy_svg__b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__d",
    cx: 0.227,
    cy: 0.039,
    r: 1.063,
    gradientTransform: "matrix(.91 0 0 1 .045 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e08f48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__t",
    cx: 0.759,
    cy: 0.158,
    r: 1.725,
    gradientTransform: "matrix(.878 0 0 1 .061 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__v",
    cx: 0.194,
    cy: 0.161,
    r: 0.973,
    gradientTransform: "matrix(1.02 0 0 1 -.01 0)",
    xlinkHref: "#trophy_svg__b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__w",
    cx: 0.279,
    cy: 0.061,
    r: 0.947,
    gradientTransform: "matrix(1.059 0 0 1 -.03 0)",
    xlinkHref: "#trophy_svg__b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__x",
    cx: 2.002,
    cy: 0.477,
    r: 0.733,
    gradientTransform: "matrix(4.807 0 0 1 -1.904 0)",
    xlinkHref: "#trophy_svg__a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__y",
    cx: 0.337,
    cy: 0.096,
    r: 1.143,
    gradientTransform: "matrix(.629 0 0 1 .186 0)",
    xlinkHref: "#trophy_svg__a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__z",
    cx: 0.219,
    cy: -0.289,
    r: 1.284,
    gradientTransform: "matrix(.863 0 0 1 .069 0)",
    xlinkHref: "#trophy_svg__b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__A",
    cx: -0.135,
    cy: 0.033,
    r: 0.981,
    gradientTransform: "matrix(2.164 0 0 1 -.582 0)",
    xlinkHref: "#trophy_svg__b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__B",
    cx: 0.147,
    cy: 0.455,
    r: 1.2,
    gradientTransform: "matrix(.699 0 0 1 .151 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed9500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__C",
    cx: 0.762,
    cy: -0.273,
    r: 1.331,
    gradientTransform: "matrix(.748 0 0 1 .126 0)",
    xlinkHref: "#trophy_svg__b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__D",
    cx: 0.667,
    cy: -0.109,
    r: 1.118,
    gradientTransform: "matrix(.805 0 0 1 .098 0)",
    xlinkHref: "#trophy_svg__b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__c",
    cx: -0.235,
    cy: -0.144,
    r: 2.099,
    gradientTransform: "matrix(.798 0 0 1 .101 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa163"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__E",
    cx: 1.827,
    cy: 0.926,
    r: 1.451,
    gradientTransform: "matrix(2.411 0 0 1 -.706 0)",
    xlinkHref: "#trophy_svg__c"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__F",
    cx: -0.045,
    cy: -0.424,
    r: 1.844,
    gradientTransform: "matrix(.832 0 0 1 .084 0)",
    xlinkHref: "#trophy_svg__b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__G",
    cx: -0.148,
    cy: -0.132,
    r: 1.718,
    gradientTransform: "matrix(1.076 0 0 1 -.038 0)",
    xlinkHref: "#trophy_svg__b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__H",
    cx: 0.002,
    cy: 0.353,
    r: 2.015,
    gradientTransform: "matrix(.645 0 0 1 .178 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcf80d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc9c0d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__I",
    cx: 0.933,
    cy: 0.104,
    r: 1.127,
    gradientTransform: "matrix(.64 0 0 1 .18 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcf80d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f78a0c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__J",
    cx: 0.5,
    cy: 0.962,
    r: 1.44,
    gradientTransform: "matrix(.671 0 0 1 .165 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#201f0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#736e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#f6eb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff369"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__K",
    cx: -0.171,
    cy: 1.07,
    r: 1.585,
    gradientTransform: "matrix(.808 0 0 1 .096 0)",
    xlinkHref: "#trophy_svg__d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__L",
    cx: 0.364,
    cy: -0.183,
    r: 1.759,
    gradientTransform: "matrix(.812 0 0 1 .094 0)",
    xlinkHref: "#trophy_svg__b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__M",
    cx: 0.155,
    cy: -0.229,
    r: 1.476,
    gradientTransform: "matrix(1.329 0 0 1 -.165 0)",
    xlinkHref: "#trophy_svg__b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__N",
    cx: 0.59,
    cy: -0.871,
    r: 4.466,
    gradientTransform: "matrix(.222 0 0 1 .389 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#22210e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#5c5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361,
    stopColor: "#8e873a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b6ae4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#d6cc58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#ece161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#faee67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff369"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__O",
    cx: 2.038,
    cy: 0.5,
    r: 0.653,
    gradientTransform: "matrix(4.519 0 0 1 -1.759 0)",
    xlinkHref: "#trophy_svg__a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__P",
    cx: 0.255,
    cy: -0.476,
    r: 2.006,
    gradientTransform: "matrix(.481 0 0 1 .259 0)",
    xlinkHref: "#trophy_svg__a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trophy_svg__S",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#e1d500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#a69d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#736d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#4a4600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#292700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#121100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#040400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__e",
    x1: 0.068,
    y1: -0.041,
    x2: 0.791,
    y2: 0.886,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b36600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__g",
    x1: 0.39,
    y1: -0.013,
    x2: 0.503,
    y2: 0.668,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db7d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__h",
    x1: 0.098,
    y1: 0.018,
    x2: 0.694,
    y2: 0.975,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c77000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#cc8b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba5e00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__i",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#trophy_svg__e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__j",
    x1: -0.012,
    y1: 0.669,
    x2: 1.998,
    y2: -0.201,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b35100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__k",
    x1: 0.447,
    y1: 0.436,
    x2: 0.948,
    y2: -0.09,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b86800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__l",
    x1: 0.033,
    y1: 1.098,
    x2: 1.018,
    y2: 0.148,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c75a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#bf6d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__m",
    x1: 0.011,
    y1: 0.201,
    x2: 0.918,
    y2: 0.944,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#781916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#963333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#450e0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__n",
    x1: 0.104,
    y1: 0.115,
    x2: 1.067,
    y2: 0.764,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#ed9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926,
    stopColor: "#b36600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__q",
    x1: 0.305,
    y1: 0.442,
    x2: 0.758,
    y2: 0.558,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#616dbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "#c2c7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__r",
    x1: 0.323,
    y1: 0.385,
    x2: 0.677,
    y2: 0.608,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#c2c7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616dbe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__f",
    x1: 0.142,
    y1: 0.311,
    x2: 0.858,
    y2: 0.689,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab665d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__s",
    x1: 0.22,
    y1: 0.309,
    x2: 0.78,
    y2: 0.691,
    xlinkHref: "#trophy_svg__f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__u",
    x1: -0.049,
    y1: 0.352,
    x2: 0.802,
    y2: 0.855,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#ed9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d96d00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__Q",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#trophy_svg__d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__R",
    x1: 1.012,
    y1: 1.054,
    x2: 0.017,
    y2: -0.064,
    xlinkHref: "#trophy_svg__d"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35352"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 22479",
    style: {
      fill: "transparent"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35351"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21458",
    d: "M5.333 3.788 2.386 8.142C1.693 7.651-1.578 4.276.935.562l.156-.23L1.352.2A2.353 2.353 0 0 1 3.16.167c-.77 1.246-.427 1.813.458 2.323l1.864 1.077-.149.221zM1.62 1.85a2.506 2.506 0 0 0 1.242 1.479l1.238.716-1.656 2.447A4.243 4.243 0 0 1 1.62 1.85z",
    transform: "rotate(-30 16.136 -.806)",
    style: {
      fillRule: "evenodd",
      fill: "#bc7800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21459",
    d: "M2.3.24 0 4.969c.772.354 5.33 1.5 7.289-2.534l.122-.25-.011-.294a2.353 2.353 0 0 0-.88-1.58c-.694 1.29-1.356 1.276-2.241.765L2.414 0 2.3.24zm3.532 2.246a2.5 2.5 0 0 1-1.9-.335l-1.24-.716L1.4 4.093a4.242 4.242 0 0 0 4.432-1.607z",
    transform: "rotate(-30 23.916 -18.234)",
    style: {
      fillRule: "evenodd",
      fill: "#bc7800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21460",
    d: "M5.333 3.548 2.386 7.9C1.693 7.411-1.578 4.037.935.323l.156-.23A2.327 2.327 0 0 1 2.7.206a1.469 1.469 0 0 0 .631 2.187l2 1.155zM4.1 3.805 2.862 3.09A2.318 2.318 0 0 1 1.55.988a4.2 4.2 0 0 0-.261 4.035 6.41 6.41 0 0 0 .936 1.517l.013.017L4.1 3.805z",
    transform: "rotate(-30 16.584 -.926)",
    style: {
      fill: "url(#trophy_svg__e)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21461",
    d: "m2.89 3.62.149-.22-1.865-1.077C.29 1.813-.053 1.246.717 0L.258.278a1.469 1.469 0 0 0 .631 2.187l2 1.155z",
    transform: "rotate(-30 15.228 -5.45)",
    style: {
      fill: "url(#trophy_svg__g)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21462",
    d: "M.726.622A2.059 2.059 0 0 1 .656 0 4.2 4.2 0 0 0 .4 4.035a6.415 6.415 0 0 0 .949 1.534l.205-.3A4.243 4.243 0 0 1 .726.622z",
    transform: "rotate(-30 17.98 -3.088)",
    style: {
      fill: "url(#trophy_svg__h)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21463",
    d: "M0 .332a2.327 2.327 0 0 1 1.61.113l.459-.278A2.353 2.353 0 0 0 .261.2L0 .332z",
    transform: "rotate(-30 15.592 -2.842)",
    style: {
      fill: "url(#trophy_svg__i)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21464",
    d: "M2.3 0 0 4.729c.772.354 5.33 1.5 7.289-2.534l.122-.25a2.327 2.327 0 0 0-.9-1.337 1.469 1.469 0 0 1-2.21.546L2.3 0zm.393 1.2 1.24.716A2.317 2.317 0 0 0 6.405 2a4.193 4.193 0 0 1-3.363 2.238 6.388 6.388 0 0 1-1.781-.052H1.24L2.691 1.2z",
    transform: "rotate(-30 24.364 -18.354)",
    style: {
      fill: "url(#trophy_svg__j)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21465",
    d: "M0 .24.116 0l1.865 1.076c.884.511 1.547.525 2.241-.765L4.21.848A1.469 1.469 0 0 1 2 1.394L0 .24z",
    transform: "rotate(-30 22.767 -22.522)",
    style: {
      fill: "url(#trophy_svg__k)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21466",
    d: "M4.592.251A2.045 2.045 0 0 0 5.166 0 4.193 4.193 0 0 1 1.8 2.243 6.408 6.408 0 0 1 0 2.188l.16-.33A4.242 4.242 0 0 0 4.592.251z",
    transform: "rotate(-30 27.467 -21.664)",
    style: {
      fill: "url(#trophy_svg__l)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21467",
    d: "m6.673 3.512-.549.951c-.274.474-1.858.073-3.538-.9S-.233 1.426.041.951L.59 0l6.083 3.512z",
    transform: "rotate(-30 39.25 -4.945)",
    style: {
      fill: "url(#trophy_svg__m)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21468",
    d: "M6.124 5.062c-.274.475-1.858.073-3.538-.9S-.233 2.025.041 1.55C.547.673 1.431.952 2.5 1.036a1.168 1.168 0 0 0 1.21-.5L4.023 0l.726.419.727.42-.31.536a1.168 1.168 0 0 0 .172 1.3c.609.885 1.292 1.512.786 2.389z",
    transform: "rotate(-30 36.082 -5.194)",
    style: {
      fill: "url(#trophy_svg__n)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21469",
    d: "M.361 1.735c.506-.877 1.307-.646 2.291-.612A1.157 1.157 0 0 0 3.789.581L4.1.044 4.023 0l-.31.536a1.168 1.168 0 0 1-1.21.5C1.431.952.547.673.041 1.55c-.079.138-.04.335.1.569l.222-.384z",
    transform: "rotate(-30 36.082 -5.194)",
    style: {
      fill: "url(#trophy_svg__a)",
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21470",
    d: "M.217 1.773c.48.811 1.042 1.368.536 2.245l-.264.458c.373.038.635-.019.732-.188.506-.877-.177-1.5-.786-2.389A1.168 1.168 0 0 1 .263.6L.572.065.461 0l-.31.536a1.157 1.157 0 0 0 .066 1.237z",
    transform: "rotate(-30 35.075 -14.732)",
    style: {
      fill: "url(#trophy_svg__o)",
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21471",
    d: "M1.318 3.961c.506-.877.047-1.374-.322-2.121A1.182 1.182 0 0 1 1.021.656l.31-.536L1.123 0l-.31.537a1.466 1.466 0 0 0-.223 1.07A1.966 1.966 0 0 1 .449 3.46L0 4.237a7.007 7.007 0 0 0 .97.326l.347-.6z",
    transform: "rotate(-30 35.231 -12.842)",
    style: {
      fill: "url(#trophy_svg__b)",
      mixBlendMode: "screen",
      opacity: 0.5,
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21472",
    d: "M1.614 2.788a3.093 3.093 0 0 1 1.162-1.264A2.665 2.665 0 0 0 3.434.7l.31-.536L3.453 0l-.31.537a1.241 1.241 0 0 1-.934.66C1.474 1.305.9 1.208.4 2.085l-.4.687a9.523 9.523 0 0 0 1.128.858l.486-.842z",
    transform: "rotate(-30 35.964 -6.883)",
    style: {
      fill: "url(#trophy_svg__p)",
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21473",
    d: "M.589 0 .041.951c-.079.138-.04.335.1.569L.688.569C.55.335.51.138.589 0z",
    transform: "rotate(-30 39.25 -4.945)",
    style: {
      fill: "url(#trophy_svg__q)",
      opacity: 0.5,
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21474",
    d: "M.549.188 0 1.139c.373.038.635-.02.732-.188L1.281 0c-.1.169-.36.227-.732.188z",
    transform: "rotate(-30 43.107 -16.761)",
    style: {
      fill: "url(#trophy_svg__r)",
      opacity: 0.5,
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21475",
    d: "m1.127 1.808.549-.95A9.523 9.523 0 0 1 .549 0L0 .951a9.464 9.464 0 0 0 1.127.857z",
    transform: "rotate(-30 41.412 -7.246)",
    style: {
      fill: "url(#trophy_svg__f)",
      opacity: 0.75,
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21476",
    d: "M2.3 0 0 4.729a5.3 5.3 0 0 0 1.228.327 8.464 8.464 0 0 0 1.464-.788 6.517 6.517 0 0 1-1.431-.082H1.24L2.691 1.2l1.24.716a2.989 2.989 0 0 0 .981.369q.072-.086.141-.172l.592-.734A1.632 1.632 0 0 1 4.3 1.154L2.3 0z",
    transform: "rotate(-30 24.364 -18.354)",
    style: {
      fill: "url(#trophy_svg__d)",
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21477",
    d: "M.549 0 0 .951a7.113 7.113 0 0 0 .97.326l.549-.951A7.007 7.007 0 0 1 .549 0z",
    transform: "rotate(-30 43.412 -13.936)",
    style: {
      opacity: 0.35,
      fill: "url(#trophy_svg__s)",
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21478",
    d: "M1.381 1.327c-.065.114-.425-.014-.8-.285S-.055.461.01.347L.211 0l1.371.98-.2.347z",
    transform: "rotate(-30 33.967 -12.365)",
    style: {
      fill: "url(#trophy_svg__t)",
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21479",
    d: "m1.465 0 4.568 2.637L10.6 5.274l-.867 1.135c-1.72 2.25-5.006 4.847-7.758 3.257S-.172 3.933.916 1.318L1.465 0z",
    transform: "rotate(-30 18.164 -5.555)",
    style: {
      fill: "url(#trophy_svg__u)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21480",
    d: "m1.286 0 3.689 2.13 3.69 2.13-.727 1.005C6.5 7.258 3.773 9.6 1.55 8.315S-.114 3.441.817 1.153L1.286 0z",
    transform: "rotate(-30 18.175 -6.268)",
    style: {
      fill: "url(#trophy_svg__v)",
      opacity: 0.75,
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21481",
    d: "m1.191 0 2.817 1.627 2.817 1.626-.605.855C5.02 5.8 2.8 7.83 1.1 6.851S-.028 2.889.782.969L1.191 0z",
    transform: "rotate(-30 18.29 -7.049)",
    style: {
      fill: "url(#trophy_svg__w)",
      opacity: 0.75,
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21482",
    d: "M1.975 9.666C-.488 8.244.259 4.182 1.38 1.587L1.946.278 1.465 0 .916 1.318C-.172 3.933-.778 8.077 1.975 9.666z",
    transform: "rotate(-30 18.164 -5.555)",
    style: {
      fill: "url(#trophy_svg__x)",
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21483",
    d: "M7.17 1.147C5.493 3.421 2.385 6.121 0 4.743c2.753 1.59 6.038-1.007 7.758-3.257L8.626.351 8.017 0 7.17 1.147z",
    transform: "rotate(-30 26.363 -11.7)",
    style: {
      fill: "url(#trophy_svg__y)",
      opacity: 0.75,
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21484",
    d: "M0 5.9c1.966 1.134 4.869-1.684 6.5-3.986L7.321.753 6.016 0l-.777 1.187C3.7 3.541 1.179 6.58 0 5.9z",
    transform: "rotate(-30 24.207 -11.124)",
    style: {
      opacity: 0.6,
      fill: "url(#trophy_svg__z)",
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21485",
    d: "M.825 8.611C.274 8.294 1.952 4.769 3.293 2.3l.677-1.245L2.142 0 1.53 1.282C.315 3.824-.827 7.658.825 8.611z",
    transform: "rotate(-30 19.557 -8.228)",
    style: {
      fill: "url(#trophy_svg__A)",
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21486",
    d: "M3.937 5.445C1.771 4.195.2 2.708.011 1.814-.089 1.343.5.443.752 0L5.5 2.74l4.746 2.74c-.264.457-.743 1.4-1.2 1.549-.871.283-2.946-.329-5.109-1.584z",
    transform: "rotate(-30 14.845 -7.266)",
    style: {
      fill: "url(#trophy_svg__B)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21487",
    d: "M3.222 4.718C1.443 3.6.158 2.3.008 1.529-.07 1.125.42.371.635 0l3.9 2.447L8.43 4.9c-.221.384-.624 1.176-1 1.292-.723.217-2.43-.357-4.208-1.474z",
    transform: "rotate(-30 15.267 -7.885)",
    style: {
      fill: "url(#trophy_svg__C)",
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21488",
    d: "M2.508 3.911a6.108 6.108 0 0 1-2.5-2.68C-.053.9.339.3.511 0l3.047 2.093L6.6 4.186c-.177.308-.5.944-.8 1.029-.569.163-1.906-.348-3.3-1.3z",
    transform: "rotate(-30 15.652 -8.436)",
    style: {
      fill: "url(#trophy_svg__D)",
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21489",
    d: "M2.086 0c-.169.293-.63.388-1.28.313L.475.84 0 1.594a2.169 2.169 0 0 0 .886-.045h.01C1.35 1.386 1.823.454 2.086 0z",
    transform: "rotate(-30 20.99 -25.232)",
    style: {
      fill: "url(#trophy_svg__c)",
      opacity: 0.75,
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21490",
    d: "m.7 1.705.323-.612C.721.648.608.267.734 0 .47.45-.077 1.307.009 1.769v.011a1.394 1.394 0 0 0 .1.286 2.527 2.527 0 0 0 .2.345l.014.021.377-.727z",
    transform: "rotate(-30 14.908 -7.284)",
    style: {
      fill: "url(#trophy_svg__E)",
      opacity: 0.75,
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21491",
    d: "M.728.042 0 1.3c.381.158.747.291 1.088.4l.336.1.585-1.018L2.174.5A11.655 11.655 0 0 1 .752 0L.728.042z",
    transform: "rotate(-30 21.442 -20.819)",
    style: {
      opacity: 0.65,
      fill: "url(#trophy_svg__F)",
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21492",
    d: "M2.4 1.239A14.815 14.815 0 0 1 .751 0L0 1.3a14.389 14.389 0 0 0 1.647 1.244l.753-1.3z",
    transform: "rotate(-30 18.555 -11.11)",
    style: {
      fill: "url(#trophy_svg__G)",
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21493",
    d: "M5.6 1.636c2.594 1.5 4.327 3.352 3.87 4.143S6.537 6 3.943 4.5-.383 1.146.073.355 3 .138 5.6 1.636z",
    transform: "rotate(-30 13.989 -8.392)",
    style: {
      fill: "#fffce4",
      opacity: 0.75,
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21494",
    d: "M5.623 1.678c2.621 1.513 4.384 3.367 3.938 4.139s-2.933.173-5.554-1.34S-.377 1.11.069.337 3 .165 5.623 1.678z",
    transform: "rotate(-30 13.873 -8.373)",
    style: {
      fill: "url(#trophy_svg__H)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21495",
    d: "M5.24 1.6C7.7 3.025 9.369 4.74 8.968 5.435s-2.721.107-5.181-1.313S-.342.987.06.292 2.78.185 5.24 1.6z",
    transform: "rotate(-30 14.037 -9.065)",
    style: {
      fill: "url(#trophy_svg__I)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21496",
    d: "M4.009 1.289C5.827 2.338 7.1 3.723 7.324 4.773a1.158 1.158 0 0 1-.1.84c-.011.019-.022.038-.035.056.671.117 1.157.061 1.345-.2a.826.826 0 0 0 .025-.038c.4-.7-1.267-2.41-3.727-3.83C2.78.418.822-.187 0 .051a8.075 8.075 0 0 1 4.009 1.238z",
    transform: "rotate(-30 13.835 -9.819)",
    style: {
      fill: "url(#trophy_svg__J)",
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21497",
    d: "M5.791 4.625a2.8 2.8 0 0 0-1.109-2.1 9.668 9.668 0 0 0-1.94-1.451A9.675 9.675 0 0 0 .517.12Q.251.047 0 0c-.055.785 1.534 2.333 3.787 3.634a16.8 16.8 0 0 0 2 .991z",
    transform: "rotate(-30 14.949 -9.31)",
    style: {
      fill: "url(#trophy_svg__K)",
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21498",
    d: "M1.051.365c.465.336.759.754.655.933s-.565.052-1.03-.284S-.083.261.021.081s.564-.052 1.03.284z",
    transform: "rotate(-30 38.463 -7.716)",
    style: {
      fill: "url(#trophy_svg__L)",
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21499",
    d: "M1.2.45C1.466.221 2.278.362 2.359.641a2.767 2.767 0 0 0 .155.857A1.543 1.543 0 0 1 2.7.206 2.327 2.327 0 0 0 1.092.093l-.156.23a5.007 5.007 0 0 0-.923 3.231A5.077 5.077 0 0 1 1.2.45z",
    transform: "rotate(-30 16.584 -.924)",
    style: {
      fill: "url(#trophy_svg__M)",
      mixBlendMode: "screen",
      opacity: 0.5,
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21500",
    d: "M1.194.185A2.917 2.917 0 0 0 0 .259a2.3 2.3 0 0 1 1.445.153L1.9.135A1.708 1.708 0 0 0 1.458 0c.051.048.089.126.015.164a.641.641 0 0 1-.279.021z",
    transform: "rotate(-30 15.568 -3.166)",
    style: {
      fill: "url(#trophy_svg__N)",
      mixBlendMode: "screen",
      opacity: 0.5,
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21501",
    d: "M1.172 4.742c.009.115-.022.235-.183.1a3.8 3.8 0 0 1-.827-3.49C.188 1.272.307.929.42.976c.074.03.09.138.095.232A4.936 4.936 0 0 1 .726.622 2.059 2.059 0 0 1 .656 0 4.2 4.2 0 0 0 .4 4.035a6.166 6.166 0 0 0 .621 1.1c.068.1.139.193.212.286q.018-.262.05-.524a4.887 4.887 0 0 1-.107-.158z",
    transform: "rotate(-30 17.98 -3.088)",
    style: {
      fill: "url(#trophy_svg__O)",
      opacity: 0.5,
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21502",
    d: "M.619 1.924c-.1.049-.192.137 0 .211A3.8 3.8 0 0 0 4.06 1.1c.055-.063.293-.337.2-.412-.067-.044-.168-.004-.251.038a4.919 4.919 0 0 0 .4-.475A2.045 2.045 0 0 0 4.983 0 4.193 4.193 0 0 1 1.62 2.243a6.214 6.214 0 0 1-1.265.014A6.878 6.878 0 0 1 0 2.216q.217-.147.429-.306l.19.014z",
    transform: "rotate(-30 27.377 -22.006)",
    style: {
      fill: "url(#trophy_svg__P)",
      opacity: 0.5,
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21503",
    d: "M.48.11A1.966 1.966 0 0 1 .171 0L0 .223a1.556 1.556 0 0 0 1.2.143C1.115.391.461.392.409.2.4.158.431.128.48.11z",
    transform: "rotate(-30 24.025 -27.144)",
    style: {
      fill: "url(#trophy_svg__Q)",
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21504",
    d: "M.583.5a2 2 0 0 0 .25.213L.725.971A1.556 1.556 0 0 1 0 0c.022.09.349.657.536.608C.583.6.592.551.583.5z",
    transform: "rotate(-30 17.842 -6.201)",
    style: {
      fill: "url(#trophy_svg__R)",
      opacity: 0.75,
      isolation: "isolate",
      mixBlendMode: "multiply",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21505",
    d: "M5.7 2.842A2.685 2.685 0 0 1 2.907 5.57 2.958 2.958 0 0 1 0 2.729 2.685 2.685 0 0 1 2.794 0 2.958 2.958 0 0 1 5.7 2.842z",
    transform: "rotate(-30 21.333 -9.818)",
    style: {
      fill: "url(#trophy_svg__S)",
      mixBlendMode: "screen",
      isolation: "isolate",
      fillRule: "evenodd"
    }
  }))));
};

export default SvgTrophy;